import * as React from "react";
import { ClipLoader } from "react-spinners";

import "./index.css";

const Loader = (props: any) => (
  <div className="sweet-loading">
    <ClipLoader
      className="loader-styling"
      sizeUnit="px"
      size={!props.size ? 20 : props.size}
      color={!props.color ? "#fff" : props.color}
      loading={true}
    />
  </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/Components/Loader/index.tsx